import React from 'react';

interface Props {
    children: string;
    name: string;
}

const Rotulo = ({ children, name }: Props): React.ReactElement =>
{
    return (
        <label htmlFor={ name }>
            { children }
        </label>
    );
}

export default Rotulo;
